import { render, staticRenderFns } from "./Slider1.vue?vue&type=template&id=dbcf73fa&"
import script from "./Slider1.vue?vue&type=script&lang=js&"
export * from "./Slider1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports